import {HeaderStyleInterpolators, TransitionPresets} from '@react-navigation/stack';
import {useTheme} from 'native-base';
import React from 'react';
import i18n from '../../lib/i18n';
import {modalOptions} from '../MainStack';
import {Nav} from '../navigation';
import {CreatePaymentAmountScreen} from './CreatePaymentAmountScreen';
import {CreatePaymentMessageScreen} from './CreatePaymentMessageScreen';
import {CreatePaymentPhoneScreen} from './CreatePaymentPhoneScreen';
import {Stack} from './navigation';

type Props = {};

export const createPaymentStackLinking = {
  initialRouteName: Nav.CreatePaymentPhoneScreen,
  screens: {
    [Nav.CreatePaymentPhoneScreen]: {
      path: '/payments/new/phone'
    },
    [Nav.CreatePaymentAmountScreen]: {
      path: '/payments/new/amount',
      parse: {phoneNumber: String}
    },
    [Nav.CreatePaymentMessageScreen]: {
      path: '/payments/new/description',
      parse: {phoneNumber: String, amount: Number, message: String}
    }
  }
};

export const CreatePaymentScreens: React.FC<Props> = () => {
  const {colors} = useTheme();
  return (
    <Stack.Navigator
      initialRouteName={Nav.CreatePaymentPhoneScreen}
      screenOptions={{
        cardStyle: {flex: 1},
        headerTitleAlign: 'center',
        headerBackTitleVisible: false,
        headerTintColor: colors.primary[600],
        headerTitleStyle: {
          color: 'black'
        },
        headerStyleInterpolator: HeaderStyleInterpolators.forUIKit
      }}>
      <Stack.Screen
        name={Nav.CreatePaymentPhoneScreen}
        component={CreatePaymentPhoneScreen}
        options={{
          title: i18n.t('send'),
          ...modalOptions
        }}
      />
      <Stack.Screen
        name={Nav.CreatePaymentAmountScreen}
        component={CreatePaymentAmountScreen}
        options={{
          title: i18n.t('send'),
          ...TransitionPresets.SlideFromRightIOS
        }}
      />
      <Stack.Screen
        name={Nav.CreatePaymentMessageScreen}
        component={CreatePaymentMessageScreen}
        options={{
          title: i18n.t('send'),
          ...TransitionPresets.SlideFromRightIOS
        }}
      />
    </Stack.Navigator>
  );
};
